<template>
  <v-overlay v-if="loading" z-index="2000">
    <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#0153CC"
    />
  </v-overlay>
</template>

<script>
import {AtomSpinner} from 'epic-spinners'
import {sync} from "vuex-pathify";

export default {
  name: "Loading",
  components: {
    AtomSpinner
  },
  computed: {
    loading: sync('app/loading')
  }
}
</script>

<style scoped>

</style>
